import {observable, action, computed } from "mobx";
import { uniqBy } from "lodash";

class CommonStore {
    @observable liftgateList = [{label: "L", value: true}];
    @observable routeTypeList = [{label: "City", value: false}, {label:"Trap", value: true}];
    @observable terminalList = [{label: "TPA", value: 1, terminalCode: "TPA"}];
    @observable trailersData =[];
    @observable tractorsData =[];
    @observable anchorPointData = [];
    @observable dropYardList = [];
    @observable isOptimizationRunning=false;
    @observable parametersData = [];
    @observable wavesData = [];
    @observable lockOptionsList = [
        { label: "Unlock", value: 0},
        { label: "Partial-lock", value: 1},
        { label: "Lock", value:2}
    ];
    @observable flexiAptList = [{label: "Y", value: true}, {label:"N", value: false}];

    @action updateAnchorPointsData(anchorPointList){
        this.anchorPointData.replace(anchorPointList);
    }

    @action updateTrailersData(trailersList){
        this.trailersData.replace(trailersList)
    }

    @action updateTractorsData(tractorsList){
        this.tractorsData.replace(tractorsList);
    }

    @action updateParametersData(parametersData){
        this.parametersData.replace(parametersData);
    }


    @action updateIsOptimizationRunningFlag(flag){
        this.isOptimizationRunning=flag;
    }

    @action updateWaveData(wavesList){
        this.wavesData.replace(wavesList);
    }

    @computed get anchorPointList(){
        return this.anchorPointData.filter(anchorPoint => anchorPoint.isSelected).map(anchor => ({label: anchor.anchorPointName , value: anchor.anchorPointName}));
    }

    @computed get trailersList(){
        return this.trailersData.map(trailer => ({label: trailer.trailerName , value: trailer.trailerId}));
    }
    @computed get trailerLengthList(){
        return uniqBy(this.trailersData.map(trailer => ({label: trailer.trailerLength , value: trailer.trailerId})),"label");
    }

    @computed get maxWaitingTimeAtStop() {
        return this.parametersData.find(
            (param) => param.parameterName === "MaxWaitingTimeAtStop"
          )?.defaultValue || "0";
    }

    @computed get weeklyAllowedHOS() {
        return (
          this.parametersData.find(
            (param) => param.parameterName === "WeeklyAllowedHOS"
          )?.defaultValue ?? "0"
        );
    }

  @action updateDropYardList(dropYardList){
    this.dropYardList.replace(dropYardList);
  }
}

export default new CommonStore();
